import { render } from "./NotFoundErrorView.vue?vue&type=template&id=0d40440d&scoped=true"
const script = {}

import "./NotFoundErrorView.vue?vue&type=style&index=0&id=0d40440d&scoped=true&lang=css"

import exportComponent from "C:\\fukunocha\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d40440d"]])

export default __exports__